import React, { Component } from "react";
import { Button, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Alert } from "react-bootstrap";
import "./Login.css";
import validator from 'validator';

const ERROR_MSG = "Must be alphanumeric with no spaces";
const FORMAT_MSG = "Invalid registration number format";
const VALID_VRM = /^(([A-Za-z]{1,2}[ ]?[0-9]{1,4})|([A-Za-z]{3}[ ]?[0-9]{1,3})|([0-9]{1,3}[ ]?[A-Za-z]{3})|([0-9]{1,4}[ ]?[A-Za-z]{1,2})|([A-Za-z]{3}[ ]?[0-9]{1,3}[ ]?[A-Za-z])|([A-Za-z][ ]?[0-9]{1,3}[ ]?[A-Za-z]{3})|([A-Za-z]{2}[ ]?[0-9]{2}[ ]?[A-Za-z]{3})|([A-Za-z]{3}[ ]?[0-9]{4}))$/;

export default class Login extends Component {

  constructor(props) {
    super(props);

    const queryString = require('query-string');
    var parsed = queryString.parse(this.props.location.search);

    this.state = {
      regMark1: "",
      regMark2: "",
      regMark3: "",
      regMark1Err: "",
      regMark2Err: "",
      regMark3Err: "",
      validationErr: "",
      redirect_uri: parsed.redirect_uri,
      alexaState: parsed.state
    };
  }

  validateForm() {
    return (validator.isAlphanumeric(this.state.regMark1) && (this.state.regMark1.length > 0));
  }

  handleChange = event => {
    if ((!validator.isAlphanumeric(event.target.value)) && (event.target.value.length > 0)) {
      switch (event.target.id) {
        case 'regMark1':
          this.setState({regMark1Err: ERROR_MSG})
          break;
        case 'regMark2':
          this.setState({regMark2Err: ERROR_MSG})
          break;
        default:
          this.setState({regMark3Err: ERROR_MSG})
          break;
      }
    } else {
      switch (event.target.id) {
        case 'regMark1':
          this.setState({regMark1Err: ""})
          break;
        case 'regMark2':
          this.setState({regMark2Err: ""})
          break;
        default:
          this.setState({regMark3Err: ""})
          break;
      }
      this.setState({
        [event.target.id]: event.target.value
      });
    }
  }


  // This is the event that is triggered on the submit button press
  handleSubmit = event => {
    event.preventDefault();
    var valid  = true;

    if (!VALID_VRM.test(this.state.regMark1) && (this.state.regMark1.length > 0)) {
      this.setState({regMark1Err: FORMAT_MSG})
      valid = false;
    }
    if (!VALID_VRM.test(this.state.regMark2) && (this.state.regMark2.length > 0)) {
      this.setState({regMark2Err: FORMAT_MSG})
      valid = false;
    }
    if (!VALID_VRM.test(this.state.regMark3) && (this.state.regMark3.length > 0)) {
      this.setState({regMark3Err: FORMAT_MSG})
      valid = false;
    }

    if (valid) {
      var data = {
        "regMark1" : this.state.regMark1,
        "regMark2" : this.state.regMark2,
        "regMark3" : this.state.regMark3
      };
      var jwt = require('jsonwebtoken');
      var token = jwt.sign(data, process.env.REACT_APP_SECRET);
      var redirectURL = this.state.redirect_uri + '#state=' + this.state.alexaState + '&access_token=' + token + '&token_type=Bearer';
      window.location.href = redirectURL;
    } else {
      event.preventDefault();
    }
  }

  render() {
    return (
      <div className="Login">
        <Form onSubmit={this.handleSubmit}>
        <Alert className="text-center Login" bsStyle="success">
            Please enter up to 3 vehicle registration numbers.
        </Alert>
          <FormGroup controlId="regMark1" bsSize="sm">
            <ControlLabel>Vehicle Registration Number 1</ControlLabel>
            <FormControl
              autoFocus
              type="text"
              placeholder="Mandatory e.g. AL07EXA"
              value={this.state.regMark1}
              onChange={this.handleChange}
              maxLength="8"
            />
            <HelpBlock>
                <p className="text-danger">{this.state.regMark1Err}</p>
            </HelpBlock>
          </FormGroup>
          <FormGroup controlId="regMark2" bsSize="sm">
            <ControlLabel>Vehicle Registration Number 2</ControlLabel>
            <FormControl
              value={this.state.regMark2}
              onChange={this.handleChange}
              placeholder="Optional"
              type="text"
              maxLength="8"
            />
            <HelpBlock>
              <p className="text-danger">{this.state.regMark2Err}</p>
            </HelpBlock>
          </FormGroup>
          <FormGroup controlId="regMark3" bsSize="sm">
            <ControlLabel>Vehicle Registration Number 3</ControlLabel>
            <FormControl
              autoFocus
              type="text"
              placeholder="Optional"
              value={this.state.regMark3}
              onChange={this.handleChange}
              maxLength="8"
            />
            <HelpBlock>
              <p className="text-danger">{this.state.regMark3Err}</p>
            </HelpBlock>
          </FormGroup>
          <Button
              block
              disabled={!this.validateForm()}
              bsStyle="success"
              type="submit"
          >
              Register
          </Button>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Login.js